import { useNavigate } from "react-router-dom";
import { MdLockOutline } from "react-icons/md";

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] text-center px-6">
      <div className="bg-primary/10 p-6 rounded-full mb-6">
        <MdLockOutline className="text-primary text-6xl" />
      </div>
      <h1 className="text-6xl font-bold text-primary mb-2">403</h1>
      <h2 className="text-2xl font-semibold text-gray-700 mb-3">
        Access Denied
      </h2>
      <p className="text-gray-500 max-w-md mb-8">
        You don't have permission to access this page. Contact your administrator
        if you believe this is a mistake.
      </p>
      <div className="flex gap-3">
        <button
          onClick={() => navigate(-1)}
          className="px-5 py-2.5 rounded-lg border border-primary text-primary font-medium hover:bg-primary/5 transition-colors"
        >
          Go Back
        </button>
        <button
          onClick={() => navigate("/dashboard")}
          className="px-5 py-2.5 rounded-lg bg-primary text-white font-medium hover:bg-primary/90 transition-colors"
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default Unauthorized;
